import { LitElement, html, nothing } from 'lit';
import { CognitoAuthMgr } from "../shared-components/utilities/authmgr.mjs";
import '../styles/login-app.css';

const authmgr = new CognitoAuthMgr({
  pool: {
    UserPoolId: "us-east-1_7spkFuTgK",
    ClientId: "2jac79u1ni4dg7uh4g5fdtghnd",
  },
});
window.authmgr = authmgr;

class LoginPanel extends LitElement {
  createRenderRoot() {
    return this;
  }

  constructor() {
    super();
    this.loginState = 'LOGGED OUT';
  }

  connectedCallback() {
    super.connectedCallback();
    this.initSSO();
  }

  async initSSO() {
    console.log('Initializing SSO process...');
    try {
      const currentURL = window.location.href;
      if (currentURL.includes('code=') || currentURL.includes('id_token=')) {
        this.isLoading = true;
        await authmgr.completeSSO(window.location);

        this.loginState = authmgr.state;
        this.userInfo = authmgr.current_login;

        this.loginState === 'LOGGED IN'
          ? this.handleSuccessfulLogin()
          : this.handleLoginFailure();
          
      } else {
        console.log('No SSO response detected in URL.');
      }
    } catch (error) {
      console.error('Error during SSO initialization:', error);
      this.handleSSOError();
    } finally {
      this.isLoading = false;
    }
  }

  sendLoginEvent(event) {
    console.log('Sending login event:', event);
    this.dispatchEvent(
      new CustomEvent('login-event', {
        detail: {
          event: event,
          state: this.loginState,
          user: this.userInfo
        }
      }
      )
    );
  }

  handleSuccessfulLogin() {
    console.log('User logged in:', this.userInfo);
    this.sendLoginEvent('success');
    this.currentPage = 'reportOptions';
  }

  handleLoginFailure() {
    console.error('Login failed or incomplete.');
    this.sendLoginEvent('failure');
    alert('Login failed. Please try again.');
  }

  handleSSOError() {
    this.sendLoginEvent('failure');
    alert('SSO initialization failed. Please try again.');
  }

  render() {
    if (this.loginState === 'LOGGED IN') {
      return nothing;
    }
    return html`
<link rel="stylesheet" href="/styles/login-app.css" />
<div class="panel" id="login-panel">
  <div class="panel-header">
    <span class="logo"></span>
    <h1>PN3 Reports</h1>
  </div>
  <div class="login-button">
    <button
      @click=${() => authmgr.attemptAFSCMESSO()}
      ?disabled=${this.isLoading}
    >
      ${this.isLoading ? 'Loading...' : 'Staff Login'}
    </button>
  </div>
</div>
`;
  }

  static get properties() {
    return {
      loginState: { type: String },
    };
  }
}

window.customElements.define("login-panel", LoginPanel);
